

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"29","height":"20"}, rest), [h('g', {"fill":"none","fill-rule":"evenodd"}, [h('path', {"fill":"#262626","d":"M23 0a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h20Zm0 1.778H3a1 1 0 0 0-1 1v10.444a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V2.778a1 1 0 0 0-1-1Z"}, []), h('g', {"transform":"translate(18 9)"}, [h('rect', {"width":"10","height":"10","x":".5","y":".5","fill":"#262626","stroke":"#FFF","rx":"5"}, []), h('path', {"fill":"#FFF","d":"M5.5 3a.5.5 0 0 1 .5.5v1.499L7.5 5a.5.5 0 0 1 0 1H6v1.5a.5.5 0 0 1-1 0V6H3.5a.5.5 0 0 1 0-1H5V3.5a.5.5 0 0 1 .5-.5Z"}, [])]), h('path', {"fill":"#262626","d":"M9 17h8l-1 2h-6zM6 19h14v1H6z"}, [])])]);
};

        